import { type Transition, type Variants } from 'framer-motion';

import { framerMotion } from '@pkg/primitives';

///
/// Present Item

export const presentTransition: Transition = {
    ease: framerMotion.easing.cubic,
    duration: framerMotion.duration.fast,
};

///
/// Leaving Item

export enum LeavingVariant {
    Initial = 'initial',
    Leave = 'leave',
}

const xLeft = [0, -20, -28];
const xRight = [0, 16, 24];

const rotateLeft = [0, 16, 48];
const rotateRight = [0, -12, -42];

export const leavingVariants: Variants = {
    [LeavingVariant.Initial]: {
        opacity: 1,
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
    },
    [LeavingVariant.Leave]: (forward?: boolean) => ({
        opacity: [1, 0.8, 0],
        translateX: forward ? xRight : xLeft,
        translateY: [0, -20, 32],
        scale: [1, 1.1, 0.8],
        rotate: forward ? rotateRight : rotateLeft,
    }),
};

export const leavingTransition: Transition = {
    type: 'spring',
    stiffness: 600,
    damping: 20,
    duration: framerMotion.duration.slow,
};
